import React, { useState, useEffect } from "react";
import Pagination from "react-responsive-pagination";
import { toast } from "react-toastify";
import axios from "utils/axios";
import { Form, Field } from "react-final-form";
import FinalFormInput from "components/FinalFormInput";
import { scrollToTop } from "utils/utils";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { modifyNFT } from "utils/wallet";

const options = ["admin", "super_user", "user"];

const Accounts = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [totalData, setTotalData] = useState<Array<any>>();
  const [formData, setFormData] = useState<Array<any>>();
  const [open, setOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [showCount, setShowCount] = useState<number>(10);
  const [accountField, setAccountField] = useState<any>(false);

  const loadPage = async () => {
    try {
      const response = await axios.post("/api/contract/getAllNFT", {
        contractId: process.env.REACT_APP_CONTRACT_ID,
      });
      setTotalPages(Math.ceil(response.data.length / showCount));
      setTotalData(response.data);
      setLoading(false);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    loadPage();
  }, []);
  useEffect(() => {
    setFormData(
      totalData?.slice((currentPage - 1) * showCount, currentPage * showCount)
    );
    scrollToTop();
    totalData && setTotalPages(Math.ceil(totalData.length / showCount));
  }, [currentPage, showCount, totalData]);

  const handlePageChange = (e: number) => {
    setCurrentPage(e);
  };
  const handleCountChange = (e: number) => {
    if (totalPages === 1 && e > showCount) {
      toast.warning(
        "All results displayed! You can see all the resources currently."
      );
      return;
    }
    setCurrentPage(1);
    setShowCount(e);
  };

  const handleEdit = (account: any) => {
    setAccountField(account);
    setOpen(true);
  };

  const handleUpdate = async (val: any) => {
    modifyNFT({ ...val, tokenId: accountField.token_id });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreate = () => {
    window.open("/create-account", "_blank");
  };

  // const handleClick = (errors: any, values: any) => {}

  return (
    <>
      {loading ? (
        <p>Please wait while loading account...</p>
      ) : (
        <>
          <div className="main-text text-right sm:text-center">
            <span
              className={`cursor-pointer ${
                showCount === 10 ? "text-button font-extrabold" : ""
              }`}
              onClick={() => handleCountChange(10)}
            >
              10
            </span>
            {" | "}
            <span
              className={`cursor-pointer ${
                showCount === 25 ? "text-button font-extrabold" : ""
              }`}
              onClick={() => handleCountChange(25)}
            >
              25
            </span>
            {" | "}
            <span
              className={`cursor-pointer ${
                showCount === 100 ? "text-button font-extrabold" : ""
              }`}
              onClick={() => handleCountChange(100)}
            >
              100
            </span>
          </div>
          <div className="grid gap-[8px]">
            {formData?.map((account, index) => (
              <div
                className="px-[20px] py-[8px] flex items-center gap-4 sm:items-start bg-gray main-text border-solid border-[1.5px] border-[#bdbdbd] rounded-sm shadow-md hover:shadow-none cursor-pointer"
                key={index}
                onClick={() => handleEdit(account)}
              >
                <img
                  src={account.metadata.media}
                  alt="art"
                  className="w-11 h-11 rounded-full"
                />
                <span>
                  {account.metadata.title} [{account.metadata.user_type}]
                  <br />
                  {"Organization: " + account.metadata.organization}
                </span>
              </div>
            ))}
            <Pagination
              total={totalPages}
              current={currentPage}
              onPageChange={(page) => handlePageChange(page)}
              maxWidth={300}
            />
            <Dialog open={open} onClose={handleClose}>
              <Form
                onSubmit={(val) => handleUpdate(val)}
                render={({ handleSubmit, errors, values }) => (
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <DialogTitle>Account Detail</DialogTitle>
                    <DialogContent>
                      <div className="grid gap-[12px] mt-[12px] w-[480px] sm:w-full">
                        <Field
                          id="title"
                          name="title"
                          placeholder="Title"
                          defaultValue={accountField.metadata?.title}
                        >
                          {(props: any) => (
                            <FinalFormInput {...props} required />
                          )}
                        </Field>
                        <Field
                          id="description"
                          name="description"
                          placeholder="Description"
                          defaultValue={accountField.metadata?.description}
                        >
                          {(props: any) => (
                            <FinalFormInput
                              {...props}
                              component="textarea"
                              rows={3}
                              required
                            />
                          )}
                        </Field>
                        <Field
                          id="accountId"
                          name="accountId"
                          placeholder="Account Address"
                          defaultValue={accountField.owner_id}
                        >
                          {(props: any) => (
                            <FinalFormInput {...props} required />
                          )}
                        </Field>
                        <Field
                          id="media"
                          name="media"
                          placeholder="Media Link"
                          defaultValue={accountField.metadata.media}
                        >
                          {(props: any) => (
                            <FinalFormInput {...props} required />
                          )}
                        </Field>
                        <Field
                          id="userType"
                          name="userType"
                          placeholder="User Type"
                          defaultValue={accountField.metadata?.user_type}
                        >
                          {(props: any) => (
                            <FinalFormInput
                              {...props}
                              component="select"
                              options={options}
                              required
                            />
                          )}
                        </Field>
                        <Field
                          id="organization"
                          name="organization"
                          placeholder="Organization"
                          defaultValue={accountField.metadata?.organization}
                        >
                          {(props: any) => (
                            <FinalFormInput {...props} required />
                          )}
                        </Field>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose}>Close</Button>
                      {/* <Button type='submit' onClick={() => handleClick(errors, values)}>
												Update
											</Button> */}
                    </DialogActions>
                  </form>
                )}
              />
            </Dialog>
          </div>
          <button
            className="high-emphasis ml-auto mt-[16px]"
            onClick={handleCreate}
          >
            CREATE AN ACCOUNT
          </button>
        </>
      )}
    </>
  );
};

export default Accounts;
